export function normalizeFileName(filename: string) {
  return filename.replace(/[/\\?%*:|"<>]/g, '-');
}